/*
 * ******************************************************************
 * Copyright (c) 2024-2026 Broadcom. All Rights Reserved.
 * Broadcom Confidential. The term "Broadcom" refers to Broadcom Inc.
 * and/or its subsidiaries.
 * ******************************************************************
 */

export enum ConsoleType {
    VLR = "VLR",
    OPERATOR = "OPERATOR",
    VMCFS = "VMCFS",
    QUORUM = "QUORUM"
}
